
// 回溯视频
import { store, mutations } from '@/observable/store'
import { getCookie } from '../commonUtils'
import { getTraceId } from "@/model/javaApi/detail";
import axios from 'axios';
import privateKeyMap from './privateKeyMap';

/**
 * 在privateKeyMap中有配置的productCode，取此version
 */
const GlobalVersion = '5.0.0'

let txrwebSrc = ''
function loadJs(url, callback) {
  var script = document.createElement('script');
  script.type = "text/javascript";
  script.id = "txrweb";
  if (typeof (callback) != "undefined") {
    if (script.readyState) {
      script.onreadystatechange = function () {
        if (script.readyState == "loaded" || script.readyState == "complete") {
          script.onreadystatechange = null;
          callback();
        }
      }
    } else {
      script.onload = function () {
        callback();
      }
    }
  }
  script.src = url;
  document.body.appendChild(script);
}


/**
 * 生产：https://txwr-api.cloud-ins.cn
 * 测试：https://recall-api.ikandy.cn
 * @type {string}
 */
let txrWebServerURL = ''

if (process.env.VUE_APP_CURRENTMODE === 'production') {
  //腾讯云生产环境sdk https://retrospective-demo.cloud-ins.cn/static/js/txrweb.1.0.1.min.js
  // 存储到新氧服务器的生产环境sdk： https://static.soyoung.com/sy-pre/txrwebprod.1.0.1.min-1600855800710.js
  // txrwebSrc = "https://retrospective-demo.cloud-ins.cn/static/js/txrweb.1.0.1.min.js"
  // txrwebSrc = "https://recall-sync.cloud-ins.cn/record/sdk/txrweb.min.js"
  // txrWebServerURL = 'https://txwr-api.cloud-ins.cn'
  txrwebSrc = "https://cdn.minishine.cn/record/txrweb.min.js"
  txrWebServerURL = 'https://trace.minishine.cn'
} else {
  // https://recall-demo.cloud-ins.cn/static/js/txrweb.1.0.1.min.js
  // https://recall-demo.cloud-ins.cn/static/js/txrweb.1.0.13.min.js
  // txrwebSrc = "https://recall-sync.cloud-ins.cn/record/sdk/txrweb.min.js"
  txrwebSrc = "https://cdn.minishine.cn/record/txrweb.min.js"
  txrWebServerURL = 'https://recall-api.ikandy.cn'

}


export default {
  methods: {
    //获取 privateKey + 版本号
    getTXInfo(defaultCode) {
      console.log('defaultCode: ', defaultCode);
      const privateKey = privateKeyMap[defaultCode];
      if (privateKey) {
        return Promise.resolve({
          privateKey,
          version: GlobalVersion
        })
      }
      return new Promise((resolve, reject) => {
        let code = defaultCode.toLowerCase();
        // const suffix = ['-1619777400670.json', '-1701241800693.json'];
        // Promise.allSettled(suffix.map(item => axios.get(`https://static.soyoung.com/sy-pre/${code}${item}`))).then(data => {
        //   const item = data.find(res => res.status === 'fulfilled');
        //   if (item) {
        //     resolve(item.value.data);
        //     return;
        //   }
        //   resolve({
        //     "privateKey": "LowAyu3rL0k5rVPHJtlpM37nK&4C157F05A97F11EB9F950242AC170002",
        //     "version": "1.0.0"
        //   })

        // });
        const url = 'https://static.soyoung.com/sy-pre/' + code + '-1701249000754.json'
        axios.get(url).then((res) => {
          resolve(res.data)
        }).catch(err => {
          resolve({
            "privateKey": "LowAyu3rL0k5rVPHJtlpM37nK&4C157F05A97F11EB9F950242AC170002",
            "version": "1.0.0"
          })
        })
      });
    },
    // 获取getbizKey
    getBizKey() {
      return new Promise((resolve, reject) => {
        getTraceId().then((data) => {
          resolve(data)
        }).catch(err => {
          resolve('')
        })
      });
    },

    // 从query中拿到参数存储
    querySetTX() {
      if (this.$route.query.TXbizKey) {
        const data = {
          bizKey: this.$route.query.TXbizKey,
          version: this.$route.query.TXversion,
          privateKey: this.$route.query.TXprivateKey,
        }
        console.log('setTXbizKey', data)
        mutations.setTXoption(data);
      } else {
        // console.log("query中缺少回溯参数")
      }
    },
    // 保证加载成功 txrweb.js
    // fn 加载成功执行的方法
    // code 商品code
    // boole 是否需要重新获取 bizkey
    async loadTX(fn, code, boole = false) {
      if (code) {
        let info = await this.getTXInfo(code);
        let bizKey;
        if (boole) {
          bizKey = await this.getBizKey();
        } else {
          bizKey = store.TXoption.bizKey || await this.getBizKey();
        }

        // 存储
        mutations.setTXoption({ bizKey, version: info.version, privateKey: info.privateKey });
      }

      if (document.getElementById("txrweb")) {
        fn()
      } else {
        loadJs(txrwebSrc, () => {
          fn()
        });
      }
    },

    // 调用视频开始录制API
    postTX(code) {
      const _this = this;
      this.loadTX(() => {

        const postData = {
          privateKey: store.TXoption.privateKey,
          version: store.TXoption.version,
          forceStart: true,
          bizKey: store.TXoption.bizKey,
          pageTitle: '商品详情',
          serverURL: txrWebServerURL
        }
        const data = {
          ...postData,
          success: () => {
            _this.STATISTICS_CONFIG.insur_recall_new_click({ "ex": { postData: JSON.stringify(postData) } }) //创建回溯单成功
            console.log('***********录制起点初始化参数****************')
            console.log(`privateKey=${data.privateKey}`)
            console.log(`version=${data.version}`)
            console.log(`forceStart=${data.forceStart}`)
            console.log(`bizKey=${data.bizKey}`)
            console.log(`serverURL=${data.serverURL}`)
            console.log('***********录制起点初始化参数****************')
            console.log('***********录制起点cookie****************')
            console.log(getCookie())
            console.log('***********录制起点cookie****************')
          },
          error: (err) => {
            _this.STATISTICS_CONFIG.insur_recall_new_fail_click({ "ex": { errmsg: JSON.stringify(err), postData: JSON.stringify(postData) } }) //创建回溯单失败
          }
        }

        let errmsg = ''
        try {

          if (window.instance) {
            _this.stopTX(() => {
              window.instance = new txrweb(data)
            })
          } else {
            window.instance = new txrweb(data)
          }
        }
        catch (err) {
          errmsg = err.message

        }
        finally {
          // 创建回溯单埋点
          _this.STATISTICS_CONFIG.insur_recall_initialize_click({ "ex": { postData: JSON.stringify(postData), tx: typeof (txrweb), errmsg: errmsg } })
        }

      }, code, true)
    },
    // 填写信息页
    infoTX(code) {
      this.loadTX(() => {
        const data = {
          privateKey: store.TXoption.privateKey,
          version: store.TXoption.version,
          bizKey: store.TXoption.bizKey,
          forceStart: false,
          serverURL: txrWebServerURL,
          success: () => {
            console.log('***********填写信息初始化参数****************')
            console.log(`privateKey=${data.privateKey}`)
            console.log(`version=${data.version}`)
            console.log(`forceStart=${data.forceStart}`)
            console.log(`bizKey=${data.bizKey}`)
            console.log(`serverURL=${data.serverURL}`)
            console.log('***********填写信息始化参数****************')
            console.log('***********填写信息cookie****************')
            console.log(getCookie())
            console.log('***********填写信息cookie****************')
          }
        }
        window.instance = new txrweb(data);


      }, code)
    },
    // 更新投保人信息
    updataTX(tbparams, orderNo, bbparams = {}) {

      this.STATISTICS_CONFIG.insur_recall_submit_click({ "ex": { orderNo: orderNo, tbName: tbparams.name } })
      console.log('***********同步投保人信息****************')
      const data = {
        orderNo: orderNo, //订单号
        tbName: tbparams.name, // 投保⼈姓名
        tbId: tbparams.idcard,// 投保⼈id
        bbName: bbparams.name || '', // 被保⼈姓名
        bbId: bbparams.idcard || ''// 被保⼈id
      }
      const _this = this;
      window.instance.updateBiz(data).then(() => {
        _this.STATISTICS_CONFIG.insur_recall_update_click({ "ex": { orderNo: data.orderNo, tbName: data.tbName } })
        console.log(data);
        console.log('***********同步投保人信息****************')
      });
    },

    // 重要信息确认
    confirmedTX(code) {
      this.loadTX(() => {
        const data = {
          privateKey: store.TXoption.privateKey,
          version: store.TXoption.version,
          bizKey: store.TXoption.bizKey,
          forceStart: false,
          serverURL: txrWebServerURL,
          success: () => {
            console.log('***********重要信息确认页初始化参数****************')
            console.log(`privateKey=${data.privateKey}`)
            console.log(`version=${data.version}`)
            console.log(`forceStart=${data.forceStart}`)
            console.log(`bizKey=${data.bizKey}`)
            console.log(`serverURL=${data.serverURL}`)
            console.log('***********重要信息确认页始化参数****************')
            console.log('***********重要信息确认页cookie****************')
            console.log(getCookie())
            console.log('***********重要信息确认页cookie****************')
          }
        }
        window.instance = new txrweb(data);

      }, code)
    },
    // 收银台
    payTX(code) {
      this.loadTX(() => {
        const data = {
          privateKey: store.TXoption.privateKey,
          version: store.TXoption.version,
          bizKey: store.TXoption.bizKey,
          forceStart: false,
          serverURL: txrWebServerURL,
          success: () => {
            console.log('***********收银台初始化参数****************')
            console.log(`privateKey=${data.privateKey}`)
            console.log(`version=${data.version}`)
            console.log(`forceStart=${data.forceStart}`)
            console.log(`bizKey=${data.bizKey}`)
            console.log(`serverURL=${data.serverURL}`)
            console.log('***********收银台初始化参数****************')
            console.log('***********收银台cookie****************')
            console.log(getCookie())
            console.log('***********收银台cookie****************')
          }
        }
        window.instance = new txrweb(data);
      }, code)
    },
    // 操作结果确认
    payResultTX(code) {
      this.loadTX(() => {
        const data = {
          privateKey: store.TXoption.privateKey,
          version: store.TXoption.version,
          bizKey: store.TXoption.bizKey,
          pageTitle: '操作结果确认',
          forceStart: false,
          serverURL: txrWebServerURL,
          success: () => {
            console.log('***********操作结果确认参数****************')
            console.log(`privateKey=${data.privateKey}`)
            console.log(`version=${data.version}`)
            console.log(`forceStart=${data.forceStart}`)
            console.log(`bizKey=${data.bizKey}`)
            console.log(`serverURL=${data.serverURL}`)
            console.log('***********操作结果确认化参数****************')
            console.log('***********操作结果确认cookie****************')
            console.log(getCookie())
            console.log('***********操作结果确认cookie****************')
          }
        }
        window.instance = new txrweb(data);
      }, code)
    },
    // 操作成功
    operatingTX(code, callback) {
      this.loadTX(() => {
        const data = {
          privateKey: store.TXoption.privateKey,
          version: store.TXoption.version,
          bizKey: store.TXoption.bizKey,
          forceStart: false,
          serverURL: txrWebServerURL,
          success: () => {
            console.log('***********操作成功初始化参数****************')
            console.log(`privateKey=${data.privateKey}`)
            console.log(`version=${data.version}`)
            console.log(`forceStart=${data.forceStart}`)
            console.log(`bizKey=${data.bizKey}`)
            console.log(`serverURL=${data.serverURL}`)
            console.log('***********操作成功初始化参数****************')
            console.log('***********操作成功cookie****************')
            console.log(getCookie())
            console.log('***********操作成功cookie****************')
            /** 提供回调入口，配合调用后端接口验证支付状态 */
            if (typeof callback === 'function') {
              callback()
            }
          }
        }
        window.instance = new txrweb(data);

      }, code)

    },
    // 调用txrweb的停止录制方法
    stopTX(callback) {
      const _this = this;
      /** 前端发起停止录制回溯 */
      if (window.instance) {
        console.log('发起停止录制视频')
        window.instance.stopBiz().then(() => {
          window.instance = null
          _this.STATISTICS_CONFIG.insur_recall_stop_click()
          console.log('发起停止录制视频接口回调触发')
          console.log('前端发起业务完成')
          console.log('=======================================')
          if (callback) {
            callback()
          }
        });
      } else {
        console.log('未初始化instance实例')
        if (callback) {
          callback()
        }
      }
    }
  },
}

export {
  privateKeyMap
}
